import React from 'react';
import './MenuTab.css';
import _ from 'lodash';
import * as element from './elements.json';
import { Route } from 'react-router-dom';
import { ReactComponent as HomeIcon } from '../../resources/images/menu_home.svg';
import { ReactComponent as TerminalsIcon } from '../../resources/images/menu_terminals.svg';
import { ReactComponent as UsersIcon } from '../../resources/images/menu_users.svg';
import { ReactComponent as CatalogIcon } from '../../resources/images/menu_catalog.svg';
import { ReactComponent as ApplicationsIcon } from '../../resources/images/menu_applications.svg';
import { ReactComponent as MerchantsIcon } from '../../resources/images/menu_merchants.svg';

export class MenuTab extends React.Component<any, any>{
    private tabElements: object[] | undefined = undefined;
    constructor(props: any) {
        super(props);
        this.tabElements = element.tabs;
    }

    private goToTabVoice(history: any, key: string) {
        switch (key) {
            case 'home':
                history.push('/');
                break;
            case 'catalog':
                history.push('/catalog');
                break;
            case 'terminals':
                history.push('/terminals');
                break;
            case 'users':
                history.push('/users');
                break;
            case 'applications':
                history.push('/applications');
                break;
            case 'merchants':
                history.push('/merchants');
                break;
            default:
                break;
        }
    }

    render() {
        return <div className={"tab-menu-container"}>
            {_.map(this.tabElements, (value: object) => {
                // @ts-ignore
                let index: number = value['index'];
                // @ts-ignore
                let key: string = value['key'];

                let size = _.size(this.tabElements);
                let className = index === 0 ? "first-tab-container" : index === (size - 1) ? "last-tab-container" : "middle-tab-container";

                return (
                    <Route render={({ history }) => {
                        return (
                            <>
                                {key === 'home' &&
                                    <div className={className} onClick={() => { this.goToTabVoice(history, key) }}>
                                        <div className={"menu-tab-element-container"}>
                                            <HomeIcon className={this.props.selectedElementIndex === index ? "menu-icon menu-tab-icon-home-selected" : "home-icon menu-tab-icon-home"} />
                                            <span className={this.props.selectedElementIndex === index ? "menu-icon menu-tab-label-selected" : "menu-icon menu-tab-label"}>Home</span>
                                        </div>
                                    </div>}
                                {this.props.userType === 'MPOS_admin' ? (
                                    <>
                                        {key === 'catalog' &&
                                            <div className={className} onClick={() => { this.goToTabVoice(history, key) }}>
                                                <div className={"menu-tab-element-container"}>
                                                    <CatalogIcon className={this.props.selectedElementIndex === index ? "menu-icon menu-tab-icon-selected" : "menu-icon menu-tab-icon"} />
                                                    <span className={this.props.selectedElementIndex === index ? "menu-icon menu-tab-label-selected" : "menu-icon menu-tab-label"}>Catalogo</span>
                                                </div>
                                            </div>}
                                        {key === 'terminals' &&
                                            <div className={className} onClick={() => { this.goToTabVoice(history, key) }}>
                                                <div className={"menu-tab-element-container"}>
                                                    <TerminalsIcon className={this.props.selectedElementIndex === index ? "menu-icon menu-tab-icon-selected" : "menu-icon menu-tab-icon"} />
                                                    <span className={this.props.selectedElementIndex === index ? "menu-icon menu-tab-label-selected" : "menu-icon menu-tab-label"}>Terminali</span>
                                                </div>
                                            </div>}
                                        {key === 'users' &&
                                            <div className={className} onClick={() => { this.goToTabVoice(history, key) }}>
                                                <div className={"menu-tab-element-container"}>
                                                    <UsersIcon className={this.props.selectedElementIndex === index ? "menu-icon menu-tab-icon-selected" : "menu-icon menu-tab-icon"} />
                                                    <span className={this.props.selectedElementIndex === index ? "menu-icon menu-tab-label-selected" : "menu-icon menu-tab-label"}>Utenti</span>
                                                </div>
                                            </div>}
                                    </>
                                ) : null}
                                {this.props.userType === 'MPOS_DEVELOPER' ? (
                                    <>
                                        {key === 'applications' &&
                                            <div className={className} onClick={() => { this.goToTabVoice(history, key) }}>
                                                <div className={"menu-tab-element-container"}>
                                                    <ApplicationsIcon className={this.props.selectedElementIndex === index ? "menu-icon menu-tab-icon-selected" : "menu-icon menu-tab-icon"} />
                                                    <span className={this.props.selectedElementIndex === index ? "menu-icon menu-tab-label-selected" : "menu-icon menu-tab-label"}>Applicazioni</span>
                                                </div>
                                            </div>}
                                        {key === 'merchants' &&
                                            <div className={className} onClick={() => { this.goToTabVoice(history, key) }}>
                                                <div className={"menu-tab-element-container"}>
                                                    <MerchantsIcon className={this.props.selectedElementIndex === index ? "menu-icon menu-tab-icon-selected" : "menu-icon menu-tab-icon"} />
                                                    <span className={this.props.selectedElementIndex === index ? "menu-icon menu-tab-label-selected" : "menu-icon menu-tab-label"}>Merchants</span>
                                                </div>
                                            </div>}
                                    </>
                                ) : null}
                            </>
                        );
                    }} />
                )
            })}
        </div >
    }
}